
   
  export const profileConfig = [
    {
      id:1,
      formName: "usr_fname",
      placeHolder: "first_name",
    },
    {
      id:2,
      formName: "usr_lname",
      placeHolder: "last_name",
    },
    {
      id:3,
      formName: "usr_status",
      placeHolder: "status",
    },

    {
      id:4,
      formName: "usr_email",
      placeHolder: "contact_email",
    },
    {
      id:5,
      formName: "usr_phone",
      placeHolder: "contact_phone",
    },
   
  ];

  export const statusOption = [
    { label: "Aktiv", id: 1 },
    { label: "inAktiv", id: 2 },
  ];
